import Vue from "vue";
import Prompt, {buttonType} from "@core/Components/Util/Prompt";

async function promptYesNoViaComponent(title, body){
  const el = document.createElement('div');
  document.body.appendChild(el);

  let vueInstance = null;

  var promptmise = new Promise((resolve, reject) => {
    vueInstance = new Vue({
      el: el,
      render: function (createElement) {
        return createElement(Prompt, {
          props: {
            title: title,
            body: body,
            buttons: [buttonType.No, buttonType.Yes],
            size: ""
          },
          on: {
            yes: () => resolve(),
            no: () => reject(),

            //hidden triggers prior to yes; schedule our rejection after the closing has been fully processed
            hidden: async () => {
              await vueInstance.$nextTick();
              reject();
            }
          }
        });
      }
    });
  });

  try {
    await promptmise;
  } finally {
    //Always cleanup after we're done
    vueInstance.$destroy();
    el.remove();
  }
}

export default promptYesNoViaComponent;